import { Container, Form, Button, Row, Col } from 'react-bootstrap';

export const UploadBox = ({
	file,
	calcFileSize,
	handleInvalidFileUpload,
	handleValidFileUpload,
	maxFileSize,
	id,
	enableRemove = false,
	commitChange,
	handleRemove = () => {},
	fileToLargeErr,
}) => {
	return (
		<Container>
			<Row className=" mt-5 ">
				<Form.Group
					as={Col}
					xs="12"
					sm={id === 0 ? 12 : 9}
					md={id === 0 ? 12 : 9}
					className="custom-file input-group"
					id={id === 0 ? '' : 'uploadBox'}>
					<label className="custom-file-label">
						{file?.name ? file.name : 'Choose File'}
					</label>
					<input
						type="file"
						className="custom-file-input"
						onChange={e => {
							calcFileSize(e.target.files?.[0]) > maxFileSize
								? handleInvalidFileUpload(id)
								: handleValidFileUpload(e.target.files[0], id);
						}}
						autoFocus
					/>
				</Form.Group>
				{enableRemove === true && (
					<Button
						as={Col}
						xs="12"
						sm="2"
						md="2"
						variant="outline-danger"
						onClick={() => {
							handleRemove(id);
						}}>
						Remove Item
					</Button>
				)}
				{fileToLargeErr === true && (
					<div class="form-text text-danger">File size limit: 5MB</div>
				)}
			</Row>
		</Container>
	);
};
